//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, Input, OnInit, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { GeneralCDMSService } from 'src/app/Services/Global/GeneralCDMS/general-cdms.service';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';


//-================ IMPORTS FOR CONSTANTS ================-\\
import { Permissions, Permissions_CDMS } from 'src/app/Constants/Admin/Permissions';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import { FilterGroupPipe } from 'src/app/Pipes/Admin/filter-group.pipe';
import Swal from 'sweetalert2';

//-================ IMPORTS FOR INTERFACES ================-\\
import { Group_New_Format } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Group.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { Folder_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Folder_FIN.interface';
import { gApproverNameRolesFIN, gApproversFolderNameFIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/GroupApproverFolder.interface';

@Component({
    selector: 'app-share-folder-lib-fin',
    templateUrl: './share-folder-lib-fin.component.html',
    styleUrls: ['./share-folder-lib-fin.component.scss', '../../../../Styles/GlobalStyles.css', '../../../../Styles/SharedFolder.scss'],
    standalone: false
})
export class ShareFolderLibFINComponent implements OnInit {

  //-========================= SECTION VARIABLES =========================-\\

  //+================== FILTER ==================+\\
  public GrouDB_Filter: string = '';
  public GrouGA_Filter: string = '';


  //+================== VARIABLES FOR PAGINATION ==================+\\
  public first: number = 0;
  public rows: number = 10;

  public first_GA: number = 0;
  public rows_GA: number = 10;

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //+================== VARIABLES GLOBAL SHARED FIN ==================+\\
  public Folder_Selected: Folder_FIN = {
    ID: 0,
    Name: '',
    ID_Folder_Top: 0,
    status: 0,
    Directory: false,
    Inheritance: 0,
    InheritanceGA: 0,
    Optional_Approvers: 0
  };

  //+================== VARIABLES FOR GROUPS ==================+\\
  public All_Groups_Approvers: Group_New_Format[] = [];
  public All_Groups_Approvers_Copy: Group_New_Format[] = [];
  public All_Groups_Approvers_Copy_Search: Group_New_Format[] = [];

  public Group_Hover: Group_New_Format = { ID_G: 0, Nombre: '', Descripcion: '', Disabled: false, Fecha_Creacion: new Date(), ID_Creador: 0, ID_Sharepoint: 0, Permission: [] }

  //+================== VARIABLES FOR PERMISIONS ==================+\\
  public Permisions: Permissions[] = Permissions_CDMS;

  //+================== VARIABLES FOR LOAD PAGE ==================+\\
  public LoadPage: boolean = false;

  //+================== VARIABLES FOR GROUP APPROVERS ==================+\\
  public GroupsApprover: gApproverNameRolesFIN[] = [];
  public ID_RG: number = 0;
  public SelectedReviewerIndex: number = -1;
  public isOpenMGA: boolean = false;

  //+================== VARIABLES FOR ROLES GROUP APPROVERS ==================+\\  
  public roleNames: { ID_RG: number, Name: string }[] = [
    { ID_RG: 1, Name: "Revisor 1" },
    { ID_RG: 2, Name: "Revisor 2" },
    { ID_RG: 3, Name: "Revisor 3" },
    { ID_RG: 4, Name: "Revisor 4" }
  ];
  public ocrInheritance: boolean = true;

  //+================== VARIABLES FOR SNAPSHOTS ==================+\\
  @Input('IDF') ID_Folder: number = 0;

  //-========================= SERVICES =========================-\\
  private Service_FIN = inject(LibraryFINService);
  private ServiceGeneralCDMS = inject(GeneralCDMSService);


  ngOnInit(): void {
    this.Load_Component();
  }

  public Check_Inheritance(): string {
    const Check_Inheritance = document.getElementById('Inheritance_Check') as HTMLInputElement;
    return Check_Inheritance.checked ? 'Activa' : 'Inactiva';
  }

  public Check_InheritanceGA(): string {
    const Check_Inheritance = document.getElementById('Inheritance_CheckGA') as HTMLInputElement;
    return Check_Inheritance.checked ? 'Activa' : 'Inactiva';
  }

  public Check_Optional_Approvers(): string {
    const Check_Optional_Approvers = document.getElementById('Optional_Approvers_Check') as HTMLInputElement;
    return Check_Optional_Approvers.checked ? 'habilitado' : ' inhabilitado ';
  }

  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  //-================== FUNCTTION FOR LOAD COMPONENT ==================-\\
  private async Load_Component(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    this.LoadPage = false;
    try {

      await this.Load_Groups_Relation();
      await this.Load_Groups();

      Loader.classList.remove('active');
      this.LoadPage = true;
    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });

      Loader.classList.remove('active');

    }

  }

  //-================== FUNCTTION FOR LOAD GROUPS WHIT RELATION A FOLDER ==================-\\
  private async Load_Groups_Relation(): Promise<boolean> {

    try {

      this.GroupsApprover = []

      const ResGetRelation: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Groups_In_Folder_FIN({ ID_Folder: this.ID_Folder }));


      if (ResGetRelation.success) {
        this.Folder_Selected = ResGetRelation.operation.Folder;
        // Si es raíz (Top <= 0), forzamos herencia en false para que use el input.
        this.ocrInheritance = this.Folder_Selected.ID_Folder_Top <= 0 ? false : (this.Folder_Selected.OCR_Regex === null);

        const groupsApprovers: gApproversFolderNameFIN[] = ResGetRelation.operation.GroupsApprovers;

        // Generar NameRole basado en la posición en la lista, no en el ID_RG
        for (let i = 0; i < groupsApprovers.length; i++) {
          const group = groupsApprovers[i];
          this.GroupsApprover.push({ 
            ID_F: group.ID_F, 
            ID_G: group.ID_G, 
            ID_RG: group.ID_RG, 
            Name: group.Name, 
            Required_RG: group.Required_RG, 
            NameRole: `Revisor ${i + 1}` 
          })
        }

      }
      return true;

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (grupos relacionados)',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });

      return false;
    }
  }

  //-================== FUNCTTION FOR LOAD GROUPS ==================-\\
  private async Load_Groups(): Promise<boolean> {
    try {

      const ResGroups: any = await firstValueFrom(this.ServiceGeneralCDMS.Get_All_Groups('fin'));

      if (ResGroups.success) {
        // Filtrar solo grupos que tengan el permiso "Approval_Flow" (Flujo de aprobación)
        this.All_Groups_Approvers = (ResGroups.operation || []).filter((group: any) => {
          return group.Permission && Array.isArray(group.Permission) && 
                 group.Permission.some((p: string) => p.toUpperCase() === 'APPROVAL_FLOW');
        });
        this.All_Groups_Approvers_Copy = this.All_Groups_Approvers.slice(this.first_GA, this.first_GA + this.rows_GA)
      }
      return true;

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (grupos)',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      return false;
    }
  }


  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR OPTIONS IN CARDS =====================&\\

  //-================== FUNCTTION FOR ENABLED OR DISABLED INHERITANCE ==================-\\
  public EnabledOrDisabledIn(): void {
    try {

      const Key_Stop: string = 'confirmar';

      Swal.fire({
        title: `¿está seguro de ${this.Folder_Selected.Inheritance === 1 ? 'detener' : 'activar'} la herencia?`,
        text: "¡El proceso no es reversible!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: `¡Sí, ${this.Folder_Selected.Inheritance === 1 ? 'detener' : 'activar'}!`
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Nuevamente ¿está seguro?',
            text: `¡Para ${this.Folder_Selected.Inheritance === 1 ? 'detener' : 'activar'} la herencia escriba ${Key_Stop} !`,
            input: 'text',
            confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
            confirmButtonColor: this.ColorConfirm,
            cancelButtonColor: this.ColorsCancel,
            showCancelButton: true,
          }).then((async result2 => {

            if (result2.isConfirmed) {

              const ValueInput: string = result2.value;

              if (ValueInput.toLowerCase() === Key_Stop.toLowerCase()) {

                const ResEoDIn: Response_FIN = await firstValueFrom(this.Service_FIN.Enable_Or_Disabled_In_FIN({ ID_Folder: this.ID_Folder }))

                if (ResEoDIn.success) {

                  const ResData = ResEoDIn.operation;

                  Swal.fire({
                    icon: 'success',
                    title: `Herencia ${ResData.Inheritance === 1 ? 'activada' : 'desactivada'}`,
                    text: `¡se ${ResData.Inheritance === 1 ? ' activó ' : 'desactivo'} la herencia correctamente!`,
                    confirmButtonColor: this.ColorConfirm
                  })
                }

                this.Load_Component();


              } else {
                Swal.fire({
                  icon: 'warning',
                  title: 'Sin coincidencia',
                  text: '¡Escriba correctamente la palabra para eliminar los grupos!',
                  confirmButtonColor: this.ColorConfirm
                })
              }
            }
          }))
        }
      })


    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      this.Load_Component();
    }

  }

  //-================== FUNCTTION FOR ENABLED OR DISABLED INHERITANCE FOR GROUPS APPROVERS ==================-\\
  public EnabledOrDisabledInGA(): void {
    try {

      const Key_Stop: string = 'confirmar';

      Swal.fire({
        title: `¿está seguro de ${this.Folder_Selected.InheritanceGA === 1 ? 'detener' : 'activar'} la herencia de grupos aprobadores?`,
        text: "¡El proceso no es reversible!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: `¡Sí, ${this.Folder_Selected.InheritanceGA === 1 ? 'detener' : 'activar'}!`
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Nuevamente ¿está seguro?',
            text: `¡Para ${this.Folder_Selected.InheritanceGA === 1 ? 'detener' : 'activar'} la herencia de grupos escriba '${Key_Stop}' !`,
            input: 'text',
            confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
            confirmButtonColor: this.ColorConfirm,
            cancelButtonColor: this.ColorsCancel,
            showCancelButton: true,
          }).then((async result2 => {

            if (result2.isConfirmed) {

              const ValueInput: string = result2.value;

              if (ValueInput.toLowerCase() === Key_Stop.toLowerCase()) {

                const ResEoDIn: Response_FIN = await firstValueFrom(this.Service_FIN.Enable_Or_Disabled_In_GA_FIN({ ID_Folder: this.ID_Folder }))

                if (ResEoDIn.success) {

                  const ResData = ResEoDIn.operation;

                  Swal.fire({
                    icon: 'success',
                    title: `Herencia de grupos aprobadores ${ResData.InheritanceGA === 1 ? 'activada' : 'desactivada'}`,
                    text: `¡se ${ResData.Inheritance === 1 ? ' activó ' : 'desactivo'} la herencia de grupos aprobadores correctamente!`,
                    confirmButtonColor: this.ColorConfirm
                  })
                }

                this.Load_Component();


              } else {
                Swal.fire({
                  icon: 'warning',
                  title: 'Sin coincidencia',
                  text: '¡Escriba correctamente la palabra para eliminar los grupos!',
                  confirmButtonColor: this.ColorConfirm
                })
              }
            }
          }))
        }
      })


    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      this.Load_Component();
    }

  }

  //-================== FUNCTTION FOR RELOAD PAGE ==================-\\
  public Reload_Page(): void {
    this.Load_Component();
  }

  //-================== FUNCTTION FOR ENABLED OR DISABLED OPTIONAL APPROVERS ==================-\\
  public En_Or_Dis_Optional_Approvers(): void {
    try {

      const Key_Stop: string = 'confirmar';

      Swal.fire({
        title: `¿está seguro de ${this.Folder_Selected.Optional_Approvers === 0 ? 'habilitar' : 'inhabilitar'} el flujo con aprobadores opcionales?`,
        text: "¡El proceso no es reversible!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: `¡Sí, ${this.Folder_Selected.Optional_Approvers === 0 ? 'habilitar' : 'inhabilitar'}!`
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Nuevamente ¿está seguro?',
            text: `¡Para ${this.Folder_Selected.Optional_Approvers === 0 ? 'habilitar' : 'inhabilitar'} el flujo con aprobadores opcionales escriba ${Key_Stop} !`,
            input: 'text',
            confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
            confirmButtonColor: this.ColorConfirm,
            cancelButtonColor: this.ColorsCancel,
            showCancelButton: true,
          }).then((async result2 => {

            if (result2.isConfirmed) {

              const ValueInput: string = result2.value;

              if (ValueInput.toLowerCase() === Key_Stop.toLowerCase()) {

                const ResEoDIn: Response_FIN = await firstValueFrom(this.Service_FIN.Enable_Or_Disabled_OptionalA_FIN({ ID_Folder: this.ID_Folder }))

                if (ResEoDIn.success) {

                  const ResData = ResEoDIn.operation;

                  Swal.fire({
                    icon: 'success',
                    title: `Flujo opcional ${ResData.Optional_Approvers === 1 ? 'habilitado' : 'inhabilitado'}`,
                    text: `¡se ${ResData.Optional_Approvers === 1 ? ' habilitó ' : 'Inhabilitó '} el flujo opcional correctamente!`,
                    confirmButtonColor: this.ColorConfirm
                  })
                }

                this.Load_Component();


              } else {
                Swal.fire({
                  icon: 'warning',
                  title: 'Sin coincidencia',
                  text: '¡Escriba correctamente la palabra para eliminar los grupos!',
                  confirmButtonColor: this.ColorConfirm
                })
              }
            }
          }))
        }
      })


    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      this.Load_Component();
    }

  }

  //&===================== END FUNCTIONS FOR OPTIONS IN CARDS =====================&\\




  //&===================== FUNCTIONS FOR SEGMENTATION BY FOLDER =====================&\\

  //-================== FUNCTTION FOR PAGINATION ==================-\\
  public onPageChangeGA(event: any): void {
    this.first_GA = event.first;
    this.rows_GA = event.rows;

    this.All_Groups_Approvers_Copy = this.GrouGA_Filter.length < 2 ? this.All_Groups_Approvers.slice(event.first, event.first + event.rows) : this.All_Groups_Approvers_Copy_Search.slice(event.first, event.first + event.rows);

  }

  //-================ FUNCTION FOR VALIDATE SEARCH ================-\\
  public Search_ValidateGA(): void {

    if (this.GrouGA_Filter.length < 2) {
      Swal.fire({
        title: 'búsqueda no valida',
        text: '¡La búsqueda es muy corta, mínimo 2 caracteres!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
    } else {
      this.Search_GroupGA();
    }

  }

  //-================ FUNCTION FOR SEARCH WHIT KEY ENTER ================-\\
  public Search_EnterGA($event: KeyboardEvent): void {
    $event.code === 'Enter' ? this.Search_ValidateGA() : 0;
  }

  //-================== FUNCTTION FOR SEARCH GROUP ==================-\\
  public Search_GroupGA(): void {
    this.GrouGA_Filter == '' || this.GrouGA_Filter.length < 2 ? this.All_Groups_Approvers_Copy = this.All_Groups_Approvers.slice(this.first_GA, this.first_GA + this.rows_GA) : (this.All_Groups_Approvers_Copy_Search = new FilterGroupPipe().transform(this.All_Groups_Approvers, this.GrouGA_Filter), this.All_Groups_Approvers_Copy = this.All_Groups_Approvers_Copy_Search.slice(this.first_GA, this.first_GA + this.rows_GA));
  }

  public ModalGAFIN(index: number): void {
    const ModalGAFIN = document.getElementById('ModalApproversG') as HTMLElement;
    !this.isOpenMGA ? ModalGAFIN.classList.add('active') : ModalGAFIN.classList.remove('active');
    this.isOpenMGA ? this.isOpenMGA = false : this.isOpenMGA = true;
    this.SelectedReviewerIndex = index;
    this.ID_RG = this.GroupsApprover[index]?.ID_RG || 0;
  }

  //-================== FUNCTTION FOR RETURN ROLE SELECTED FOR CHANGE ==================-\\
  public rolGroupSelected(): string {
    const isFind: { ID_RG: number, Name: string } | undefined = this.roleNames.find((item: { ID_RG: number, Name: string }) => item.ID_RG === this.ID_RG)
    return isFind !== undefined ? isFind.Name : 'not Found';
  }

  //-================== FUNCTTION FOR ADD GROUP TO GROUPS IN FOLDER ==================-\\
  public ChangeGroupApprover(Group: Group_New_Format): void {

    Swal.fire({
      title: '¿Desea cambiar el grupo aprobador a la carpeta?',
      text: `¡Al terminar, guarde sus cambios!`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, cambiar!'
    }).then((result) => {

      if (result.isConfirmed) {
        // Usar el índice para acceder directamente al revisor correcto
        if (this.SelectedReviewerIndex >= 0 && this.SelectedReviewerIndex < this.GroupsApprover.length) {
          this.GroupsApprover[this.SelectedReviewerIndex].ID_G = Group.ID_G;
          this.GroupsApprover[this.SelectedReviewerIndex].Name = Group.Nombre;
        }
        this.ModalGAFIN(this.SelectedReviewerIndex)

        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'success',
          title: '¡Grupo asignado!'
        })
      }

    })
  }

  //-================== FUNCTTION FOR INITIALS CARD ==================-\\
  public Format_Initials(Name: string): string {
    let Initials: string = '';
    let NameSplit: string[] = Name.split(' ');

    Initials += NameSplit[0][0] || '?';
    NameSplit.length > 1 ? Initials += NameSplit[1][0] || '' : Initials += NameSplit[0][1] || '?';

    return Initials.toUpperCase();
  }

  //-================== FUNCTTION FOR ENABLED OR DISABLED INHERITANCE FOR GROUPS APPROVERS ==================-\\
  public SaveChangesApproversGroups(): void {
    try {

      const isValid: boolean = this.ValidateDataGroupsApprovers();

      if (isValid) {

        const confirmationKey: string = 'confirmar';

        Swal.fire({
          title: 'Confirmación de Modificación',
          text: `¿Está seguro que desea modificar los grupos aprobadores en esta carpeta? Actualmente, la herencia de grupos está ${this.Folder_Selected.InheritanceGA === 1 ? 'activa' : 'inactiva'}.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          confirmButtonText: 'Sí, modificar'
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire({
              title: 'Confirmación Adicional',
              text: `Para proceder, por favor escriba la palabra '${confirmationKey}' para confirmar la modificación de los grupos aprobadores.`,
              input: 'text',
              confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
              confirmButtonColor: this.ColorConfirm,
              cancelButtonColor: this.ColorsCancel,
              showCancelButton: true,
            }).then(async (result2) => {
              if (result2.isConfirmed) {
                const userInput: string = result2.value;

                if (userInput.toLowerCase() === confirmationKey.toLowerCase()) {
                  // Garantizar que todos los grupos mantengan el orden visual como ID_RG en base de datos
                  this.GroupsApprover.forEach((group, index) => {
                     group.ID_RG = index + 1;
                  });

                  // Guardar Grupos Aprobadores
                  const resGroups = await firstValueFrom(this.Service_FIN.Set_Group_Approver_FIN({ ID_Folder: this.ID_Folder, Groups: this.GroupsApprover }));
                  
                  // Guardar OCR Regex
                  const ocrRegex = this.ocrInheritance ? null : (this.Folder_Selected.OCR_Regex || '');
                  const resOCR = await firstValueFrom(this.Service_FIN.Edit_OCR_Regex({ ID_Folder: this.ID_Folder, OCR_Regex: ocrRegex }));

                  if (resGroups.success && resOCR.success) {
                    Swal.fire({
                      icon: 'success',
                      title: 'Modificación Exitosa',
                      text: 'La configuración de la carpeta ha sido actualizada correctamente.',
                      confirmButtonColor: this.ColorConfirm
                    });
                    this.Reload_Page();
                  } else {
                    Swal.fire({
                      icon: 'error',
                      title: 'Error en la Modificación',
                      text: 'Ocurrió un error al guardar los cambios. Por favor, intente nuevamente.',
                      confirmButtonColor: this.ColorConfirm
                    });
                    this.Reload_Page();
                  }
                } else {
                  Swal.fire({
                    icon: 'warning',
                    title: 'Confirmación Incorrecta',
                    text: 'La palabra ingresada no coincide. Por favor, escriba correctamente la palabra para confirmar la modificación.',
                    confirmButtonColor: this.ColorConfirm
                  });
                }
              }
            });
          }
        });

      }


    } catch (error) {
      Swal.fire({
        title: 'Error del Sistema',
        text: 'Ha ocurrido un error inesperado. Por favor, notifique este error a su supervisor.',
        icon: 'error',
        confirmButtonColor: this.ColorConfirm
      });

      this.Load_Component();
    }


  }

  //-================== FUNCTTION FOR VALIDATION OF GROUPS APPROVERS ==================-\\
  private ValidateDataGroupsApprovers(): boolean {

    if (this.GroupsApprover.length === 0) {
      return true;
    }

    let count: number = 0;

    for (const group of this.GroupsApprover) {
      if (group.ID_G === 0) {

        Swal.fire({
          title: `Grupo no Seleccionado para ${group.NameRole}`,
          text: 'Por favor, seleccione un grupo para el rol especificado.',
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        });

        return false;
      }

      if (group.Required_RG === false) {
        count++;
      }
    }

    /*if (count === this.GroupsApprover.length && this.GroupsApprover.length > 1) {
      Swal.fire({
        title: 'Aprobadores opcionales inválidos',
        text: 'Debe haber al menos un aprobador obligatorio en el flujo de aprobación.',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });

      return false;
    }*/

    return true;

  }

  public setOptionalApprover(group: gApproverNameRolesFIN): void {

    if(this.GroupsApprover.length === 1){
      return;
    }

    let count: number = 0;

    for (const group of this.GroupsApprover) {
      if (group.Required_RG === false) {
        count++;
      }
    }

    /*if (count === this.GroupsApprover.length && this.GroupsApprover.length > 1) {
      Swal.fire({
        title: 'Aprobadores opcionales inválidos',
        text: 'Debe haber al menos un aprobador obligatorio en el flujo de aprobación.',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      }).then((result) => {
        group.Required_RG = true;
      });
    }*/
  }



  //&===================== END FUNCTIONS FOR SEGMENTATION BY FOLDER =====================&\\



  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  public SetInfoGroupApprover(groupApprover: gApproverNameRolesFIN): void {
    const isfind: Group_New_Format | undefined = this.All_Groups_Approvers.find((group: Group_New_Format) => group.ID_G === groupApprover.ID_G);

    if (isfind !== undefined) {
      this.Group_Hover = isfind
    }
  }

  public Unsetgroup() {
    this.Group_Hover = { ID_G: 0, Nombre: '', Descripcion: '', Disabled: false, Fecha_Creacion: new Date(), ID_Creador: 0, ID_Sharepoint: 0, Permission: [] }
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //&===================== FUNCTIONS FOR ADD OR DELETE APPROVERS =====================&\\
  public Remove_Last_Approver(index: number): void {
    if (index === this.GroupsApprover.length - 1) {
      this.GroupsApprover.splice(index, 1);
    }
  }

  public Add_New_Approver(): void {
    const nextIdRg = this.GroupsApprover.length > 0 ? Math.max(...this.GroupsApprover.map(g => g.ID_RG || 0)) + 1 : 1;

    const newApprover = {
      ID_RG: nextIdRg,
      NameRole: 'Revisor ' + (this.GroupsApprover.length + 1),
      Name : '',
      ID_G: 0,
      ID_F: this.ID_Folder,
      Required_RG: false
    };

    this.GroupsApprover.push(newApprover);
  }

  //&===================== END FUNCTIONS FOR ADD OR DELETE APPROVERS =====================&\\
    
}
